function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterfortmtu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b6074e97-1fef-4ee8-a511-aac9d9a3aa26",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e0ba06d2-0d06-47ce-973d-780fe45df1f6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.55-103.25a4.76,4.76,0,0,0-6.36,2.39,5.69,5.69,0,0,0,0,3.82,4.75,4.75,0,0,0,5.91,2.55,5.24,5.24,0,0,0,2.6-2.33,5.47,5.47,0,0,0,.26-3.72A5.55,5.55,0,0,0,32.55-103.25Zm-2.94-2.1a6.32,6.32,0,0,1,6.33,2.93,6.5,6.5,0,0,1-1.53,8.6,5.35,5.35,0,0,1-3.91,1.21,4.12,4.12,0,0,1-2.68-.54,6.41,6.41,0,0,1-3-8.69A6.52,6.52,0,0,1,29.61-105.35ZM42-96.61l1.31,1.27-2,2,2,1.94-.57.57a2.24,2.24,0,0,1-.73.58A5.14,5.14,0,0,1,41-91.16l-.9-.91-.95.93-.94.93-.63-.5c-.35-.28-.62-.57-.62-.66a4.55,4.55,0,0,1,.91-1.08l.92-.89-.92-.92a5.44,5.44,0,0,1-.91-1.06A2.85,2.85,0,0,1,37.5-96l.57-.58,2,2Zm-19,2.4,0,0a6.13,6.13,0,0,1,.49.69l.39.58-.79.75c-1.72,1.66-2,2.68-2,7,0,2.67,0,3.19.24,3.38s1,.23,6.76.24h3.6c5.94,0,7.94,0,8.07-.18a10.08,10.08,0,0,0,.18-3v-2.85h1.78v3.25c0,3.12-.15,3.55-1.14,4.17l-.57.35-9,0h-3.7c-3.68,0-5.62,0-6.05-.12a2.14,2.14,0,0,1-1.3-.74c-.52-.58-.67-1-.68-2.83v-.42c0-.52,0-1.14,0-1.89a15.16,15.16,0,0,1,.34-4l.05-.18a8.56,8.56,0,0,1,2.33-3.51c.47-.43.9-.74,1-.66Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a11b712d-85f4-4135-a51b-62f24dfeafdc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-51.85-99.61a4.87,4.87,0,0,0,0,3.24,4,4,0,0,0,5,2.17,4.4,4.4,0,0,0,2.2-2,4.7,4.7,0,0,0,.23-3.16,4.67,4.67,0,0,0-2.08-2.3A4,4,0,0,0-51.85-99.61Zm8.29-1.33a5.54,5.54,0,0,1-1.31,7.31,4.57,4.57,0,0,1-3.32,1,3.55,3.55,0,0,1-2.27-.45A5.45,5.45,0,0,1-53-100.44a5.54,5.54,0,0,1,4.07-3A5.36,5.36,0,0,1-43.56-100.94Zm8.23,4.47a.88.88,0,0,1,.87,0,1.17,1.17,0,0,1,.8,1.16v.06c0,.53,0,.46-3.54,4.24-3.35,3.53-3.56,3.77-4,3.79h-.25c-.58,0-.73-.15-2-1.78s-1.4-1.78-1.4-2.11a1.34,1.34,0,0,1,.79-1.16c.7-.29,1-.14,2,1a10.18,10.18,0,0,0,.86,1c.16-.21,1.48-1.59,2.84-3l.37-.38L-37-94.84l.33-.33C-35.95-95.91-35.4-96.44-35.33-96.47ZM-54.53-94h0a4.24,4.24,0,0,1,.36.5l.06.09.33.49-.67.64c-1.46,1.41-1.71,2.27-1.71,5.93,0,2.26,0,2.7.2,2.87l0,0,0,0c.28.12,1.29.15,5.67.16h3.06c5,0,6.74,0,6.85-.15a7.32,7.32,0,0,0,.15-2.36v-1h1.51v1.07c0,2.57-.12,3-.89,3.48l-.08,0-.47.31-7.61,0h-3.15c-3.12,0-4.77,0-5.13-.11a1.82,1.82,0,0,1-1.11-.63c-.43-.48-.56-.81-.57-2.39v-.36c0-.45,0-1,0-1.61a11.62,11.62,0,0,1,.33-3.57,7.24,7.24,0,0,1,2-3,3.21,3.21,0,0,1,.78-.57Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e0ad0400-dbc4-4f12-ab99-ead597db7938"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.07,
    width: 24,
    height: 22.86,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "afb19a98-4d3d-446f-ba2d-341395dd34c1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -0.93,
    width: 26,
    height: 24,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e109f119-22f5-4c82-9bc4-eb39507355fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,.36A3.71,3.71,0,0,0,3.48,2.13l-.18.46H2c-1.26,0-1.37,0-1.65.35s-.4.69,0,1.12.39.35,1.65.35H3.3l.18.46A3.66,3.66,0,0,0,5,6.64a3.45,3.45,0,0,0,2.71,0A3.71,3.71,0,0,0,9.34,4.89l.15-.48H23.4l.3-.35c.4-.43.4-.69,0-1.12l-.3-.35H9.49l-.15-.48A3.71,3.71,0,0,0,7.73.34,3.5,3.5,0,0,0,5,.36Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af5963e8-8fdd-482f-b04f-5725c08018c4"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.07,
    width: 24,
    height: 23,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f778834e-f878-44bf-bcd7-3981c364d62a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.88,8.25A3.41,3.41,0,0,0,13.14,10l-.32.71H6.67c-6,0-6.19,0-6.43.29a.75.75,0,0,0,0,1.1c.24.26.42.27,6.44.27h6.18l.08.32a3.79,3.79,0,0,0,1.4,1.82,3,3,0,0,0,3.85-.55,3.53,3.53,0,0,0,.69-1.08l.16-.51h2.23c2.05,0,2.24,0,2.47-.27a.93.93,0,0,0,.26-.55.93.93,0,0,0-.26-.55c-.23-.25-.42-.28-2.47-.28H19l-.14-.44A3.2,3.2,0,0,0,14.88,8.25Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bba88fe4-b318-4831-be99-95d9e48ea3d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,16.39a3,3,0,0,0-1.42,1.54l-.31.67H1.9c-1.52,0-1.91.18-1.9.91s.38.9,1.9.9H3.23l.31.66a3,3,0,0,0,2.85,1.86,3.15,3.15,0,0,0,2.94-2.19l.08-.33h7c6.84,0,7,0,7.3-.29a.94.94,0,0,0,.33-.61.93.93,0,0,0-.33-.62c-.34-.29-.46-.29-7.3-.29h-7l-.08-.32a3.24,3.24,0,0,0-1.5-1.83A3.13,3.13,0,0,0,5,16.39Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fd301922-0271-4a94-9a9a-59fcf3355982"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-137 84.5 -130.5 91.05 -131.94 92.5 -137 87.41 -142.06 92.5 -143.5 91.05 -137 84.5",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf72f87a-a039-4668-b8d0-2200809ac3db"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-97 92.5 -103.5 85.95 -102.06 84.5 -97 89.59 -91.94 84.5 -90.5 85.95 -97 92.5",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -765.66,
    y: -186.11,
    width: 1528,
    height: 860,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#e0ad0400-dbc4-4f12-ab99-ead597db7938)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#afb19a98-4d3d-446f-ba2d-341395dd34c1)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#e109f119-22f5-4c82-9bc4-eb39507355fc)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#af5963e8-8fdd-482f-b04f-5725c08018c4)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -0.93,
    width: 26,
    height: 8.96,
    style: {
      fill: "#516983"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#f778834e-f878-44bf-bcd7-3981c364d62a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#af5963e8-8fdd-482f-b04f-5725c08018c4)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 6.65,
    width: 26,
    height: 9.6,
    style: {
      fill: "#516983"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#bba88fe4-b318-4831-be99-95d9e48ea3d4)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#af5963e8-8fdd-482f-b04f-5725c08018c4)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 14.94,
    width: 26,
    height: 8.99,
    style: {
      fill: "#516983"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterfortmtu);
export default __webpack_public_path__ + "static/media/filterfortmtu.c4f0fdb8eef87dd6d4371c4379c646fb.svg";
export { ForwardRef as ReactComponent };